<template>
  <ExtraInfoModal title="Day Or">
    When the "Day Or" value is off, this schedule will connect day of the month and day of the week entries
    using OR logic; when on it will connect them using AND logic.
  </ExtraInfoModal>
</template>

<script lang="ts" setup>
  import ExtraInfoModal from '@/components/ExtraInfoModal.vue'
</script>